import { useState } from "react";
import { GetHelpLink, ForgotPasswordLink, GenericLink } from "../../atoms/TextLink";
import CommonModalPopup from "../CommonModalPopup";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { gaEvent } from "../../../utilities/analytics";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const ExternalLink = (props) =>{
    const {href,children,title,newTab=true} = props;
    const { hostname } = href && href !==""  && href !=="/" ? new URL(href) : {};
    const [showPopUp, setShowPopUp] = useState(false);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { persistItemsReducer } = useSelector((state) => state);
    useEffect(()=> {
        // var gaEventHref =document.getElementsByTagName("a")
        // gaEventHref?.addEventListener("click",hadleConfirmClick)
        document.querySelector("body").addEventListener("click", function(e) {
            var anchor = e.target.id;
            if(anchor !== null && anchor == "gaEvent_id" && showPopUp) {
              if(props?.type==="forgotpassword"){
                gaEvent("ForgotPasswordPopupYesBtn",persistItemsReducer);
            }
            else if(props?.type==="privacypolicy"){
                gaEvent("PrivacyPolicyYesBtn",persistItemsReducer);
            }
            }
          }, false);
    },[showPopUp]) 

    const clickHandler = (e) =>{
        e.preventDefault();
        if(href==="/"){
            navigate("/");
            return;
        }
        window.open(href, "_blank");
        if(props?.type==="forgotpassword"){
            gaEvent("ForgotPassword",persistItemsReducer);
        }
        else if(props?.type==="privacypolicy"){
            gaEvent("PrivacyPolicy",persistItemsReducer);
        }
    }
 const HandleCloseBtn = () => {
    if(props?.type==="forgotpassword"){
        gaEvent("ForgotPasswordPopupCloseBtn",persistItemsReducer);
    }
    else if(props?.type==="privacypolicy"){
        gaEvent("PrivacyPolicyPopupCloseBtn",persistItemsReducer);
    }
}
const hadleConfirmClick = () => {
    setShowPopUp(false)
    if(props?.type==="forgotpassword"){
        gaEvent("ForgotPasswordPopupYesBtn",persistItemsReducer);
    }
    else if(props?.type==="privacypolicy"){
        gaEvent("PrivacyPolicyYesBtn",persistItemsReducer);
    }
}
    
    const LinkRender = (props) =>{
        const {type} = props;
        switch(type){
            case "forgotpassword":
            return <ForgotPasswordLink isJPNO={persistItemsReducer?.selectedSOData?.soCode == "JPNO"} href={href} onClick={clickHandler}>{children}</ForgotPasswordLink>
            case "privacypolicy": 
            return <GetHelpLink href={href} onClick={clickHandler}>{children}</GetHelpLink>   
            default:
            return <GenericLink href={href} onClick={clickHandler}>{children}</GenericLink>       

        }
    }

    return(
    <>
        {LinkRender(props)} 
        {href!=="/" && showPopUp && <CommonModalPopup 
                logout
                type="warning"
                show={true}
                title={title} 
                body={t("privacyBody",{link:`<a target="_blank" href=${href} id="gaEvent_id" >${hostname ? hostname : href}</a>`})}
                confirm={{title:t("Yes"),handler:(e)=>{ !newTab ? window.location.href=href : (function(){window.open(href,"_blank");window.focus();})(); hadleConfirmClick(e)}}}
                close={{handler:(e)=>{setShowPopUp(false); HandleCloseBtn(e)}}}
                cancel={{title:t("NotRightNow"), handler:()=>{setShowPopUp(false)}}}
                />}
    </>
    )
}

export default ExternalLink;